import { useState, useEffect, useMemo } from "react";
import { FaTimes } from "react-icons/fa";
import Fuse from "fuse.js";
import { searchIndex } from "../data/searchIndex";

const SearchPopup = ({ isOpen, onClose }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  // Tạo Fuse chỉ 1 lần (hoặc khi searchIndex đổi)
  const fuse = useMemo(() => {
    return new Fuse(searchIndex, {
      keys: ["title", "excerpt"],
      threshold: 0.3,
    });
  }, []);

  // ESC để đóng
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  // Click overlay để đóng
  const handleOverlayClick = () => {
    onClose();
  };

  // Xử lý search
  const handleSearch = (e) => {
    const text = e.target.value;
    setQuery(text);
    if (text.trim()) {
      setResults(fuse.search(text).map((r) => r.item));
    } else {
      setResults([]);
    }
  };

  return (
    <div
      className={`search-wrap ${isOpen ? "open" : ""}`}
      onClick={handleOverlayClick}
    >
      <div
        className="search-inner"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Icon close */}
        <FaTimes
          className="search-close"
          onClick={onClose}
          style={{ cursor: "pointer" }}
        />

        {/* Ô input search */}
        <div className="search-cell">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="search-field-holder">
              <input
                type="search"
                className="main-search-input"
                placeholder="Thông tin bạn muốn tìm..."
                autoFocus
                value={query}
                onChange={handleSearch}
              />
            </div>
          </form>

          {/* Kết quả tìm kiếm */}
          {results.length > 0 && (
            <ul className="list-group mt-4 search-results overflow-auto">
              {results.map((item, i) => (
                <li
                  key={i}
                  className="list-group-item bg-dark text-light border-secondary"
                >
                  {item.type && (
                    <p className="small text-uppercase text-secondary mb-1">
                      {item.type}
                    </p>
                  )}
                  <a
                    href={item.url}
                    className="fw-semibold text-info d-block"
                  >
                    {item.title}
                  </a>
                  {item.excerpt && (
                    <p className="small text-light-50 mb-0">{item.excerpt}</p>
                  )}
                </li>
              ))}
            </ul>
          )}

          {/* Không tìm thấy */}
          {query.trim() && results.length === 0 && (
            <p className="text-gray-500 mt-4 text-center">
              Không tìm thấy kết quả phù hợp.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchPopup;
